export default {"src":"/_next/static/media/dropdown.da00fd26.svg","height":24,"width":40,"blurWidth":0,"blurHeight":0};